import request from "@/utils/request";

export function handleListApi(data) {
    return request({
        url: "/admin/work_game_vips",
        method: "get",
        params: data
    });
}

export function handleCreateStoreApi(data) {
    if (data.id) {
        return request({
            url: "/admin/work_game_vips/" + data.id,
            method: "put",
            data
        });
    } else {
        return request({
            url: "/admin/work_game_vips",
            method: "post",
            data
        });
    }
}

export function handleDeleteApi(data) {
    return request({
        url: "/admin/work_game_vips/" + data.id,
        method: "delete"
    });
}


export function handleLogDataApi(data) {
    return request({
        url: "/admin/work_game_vips",
        method: "get",
        params: data
    });
}

export function handleGetGameApi() {
    return request({
        url: "/admin/get_games",
        method: "get",
    });
}

